import { useEffect } from 'react'

import { DEFAULT_THEME_MATCH_MEDIA, DARK_THEME_CLASS } from '@/constants'

export function useForceDarkThemeOnRender() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const isDark = !window.matchMedia(DEFAULT_THEME_MATCH_MEDIA).matches
      if (!isDark) {
        document.documentElement.classList.add(DARK_THEME_CLASS)
      }
    }
  }, [])
}
